import { AudienceNetworkPositionEnum, OldAudienceNetworkPositionEnum } from "../enums";

export const mapAudienceNetworkPosition: any = {
    [OldAudienceNetworkPositionEnum.classic]: AudienceNetworkPositionEnum.CLASSIC,
    [OldAudienceNetworkPositionEnum.instream_video]: AudienceNetworkPositionEnum.INSTREAM_VIDEO,
    [OldAudienceNetworkPositionEnum.rewarded_video]: AudienceNetworkPositionEnum.REWARDED_VIDEO,
}